// extracted by mini-css-extract-plugin
module.exports = {"navbars":"navbar_navbars__JU8ML","icon":"navbar_icon__1WLuI"};